import React from 'react';

/**
 * Logo component displayed at the top-left of the word cloud
 */
const WordCloudLogo = () => {
    return (
        <div className="forever-hearts-logo">
            <img src={require('../../../../assets/viewlogies_forever_logo.png')} alt="Forever IN OUR HEARTS" />
        </div>
    );
};

export default WordCloudLogo;
